import { Component, OnInit, ViewChild } from '@angular/core';

import { RestapiService } from '../../services/restapi.service';
import { RoutingService } from '../../services/routing.service';
import { UserService } from '../../services/user.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('content') content;
  @ViewChild('login') login;
  form: NgForm;
  form2: NgForm;
  view: string = 'login'
  formdata: any = {
    email: '',
    password: ''
  }

  formdata2 = {
    email: '',
    password: '',
    passwordConfirm: '',
    firstname: '',
    lastname: '',
    docid: '',
    docextend: '',
    phone: '',
    address: '',
    gender: undefined,
    age: '',
    help1: false,
    help2: false,
    help3: false,
    type: 2,
    status: 1,
    user_type: 2
  }

  constructor(
    public api: RestapiService,
    public route: RoutingService,
    public user: UserService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  callLogin(form: NgForm) {
    console.log('login!',form);
  //  console.log('login DATA!',form.value.email, form.value.password);
    if(form.valid){
      this.user.login(form.value, '/');
    }
    else{
      Object.values(form.controls).forEach(control=>{
        control.markAsTouched();
      })
    //  this.user.presentToast('Datos invalidos', 'warning',2000)
    }
  }
  register(/* form: NgForm */) {
    console.log('register', this.formdata2);
    this.user.signin(this.formdata2)
    .subscribe(resData => {
      console.log('signin resData', resData);
      if (resData.status === true) {
        //this.presentToast('Cuenta registrada', 'success');
        this.view = 'mail_sent';
      }
      else {
       // this.presentToast('Esta cuenta ya esta registrada:' + resData.error, 'danger');
      }
    });
   /*  if (this.formdata.passwordConfirm != this.formdata.password) {
   //   this.presentToast('Las contraseñas no coinciden', 'danger');
    }
    if (form.valid && (this.formdata.passwordConfirm == this.formdata.password)) {
   //   this.confirm()

    }
    else {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      })
    //  this.userService.presentToast('Datos invalidos', 'warning', 2000)
    } */

  }

  openLoginModal() {
    setTimeout(() => {
      this.modalService.open(this.content, { windowClass: "app-modal animate__fast animate__animated animate__bounceIn" });
    }, 100);
  }

}
